<div class="flex w-full flex-col justify-start gap-3 xs:gap-4 sm:gap-6 lg:gap-8">
  <div>
    <pay-input
      [autoComplete]="'new-password'"
      [label]="'password-reset.input.password.label' | translate"
      [formControl]="newPassword"
      type="password"
      [overrideValidation]="true"
      [showPasswordSvg]="true" />
    <div class="flex flex-col gap-5">
      <div class="mt-2 grid grid-cols-3 gap-1">
        <div class="h-1 rounded-full" [ngClass]="bgColorFirstBar"></div>
        <div class="h-1 rounded-full" [ngClass]="bgColorSecondBar"></div>
        <div class="h-1 rounded-full" [ngClass]="bgColorThirdBar"></div>
      </div>
      <h4
        class="is-heading break-long-words is-sm group mb-2 flex items-end font-heading text-base font-medium group-[.is-box]:mt-0 xs:text-lg sm:text-lg lg:text-lg">
        {{ bgColorText }}
      </h4>
    </div>
    <div class="flex flex-col gap-1">
      <pay-login-password-reset-requirement [requirementText]="'password-reset.create-password-requirements.uppercase.label'" [isCorrect]="hasUppercase" />
      <pay-login-password-reset-requirement [requirementText]="'password-reset.create-password-requirements.lowercase.label'" [isCorrect]="hasLowercase" />
      <pay-login-password-reset-requirement [requirementText]="'password-reset.create-password-requirements.number.label'" [isCorrect]="hasNumber" />
      <pay-login-password-reset-requirement [requirementText]="'password-reset.create-password-requirements.symbol.label'" [isCorrect]="hasSymbol" />
      <pay-login-password-reset-requirement [requirementText]="'password-reset.create-password-requirements.characters.label'" [isCorrect]="hasCharacters" />
    </div>
  </div>
  @if (this.error) {
    <pay-login-error-badge [error]="this.error!" />
  }
  <pay-button-primary (click)="submit()" [loading]="isSubmitting" [disabled]="!isValid()" [rounded]="'rounded-lg'">
    {{ 'password-reset.button.label' | translate }}
  </pay-button-primary>
</div>
